import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as icons from 'react-bootstrap-icons';

export default function AppointmentCount() {
    const [dayLimit, setDayLimit] = useState(0);
    const { dateSearch, weeklyLimit, extraCount, appointments, current } = useSelector((state) => ({
        dateSearch: state.setting.dateSearch,
        weeklyLimit: state.setting.weeklyLimit,
        extraCount: state.setting.extraCount,
        appointments: state.appointments.appointments,
        current: state.staff.current,
    }));
    useEffect(() => {
        if(dateSearch.dow !== '' && weeklyLimit) {
            weeklyLimit.find(item => {
                if(+item.id === +dateSearch.dow) {
                    setDayLimit(item.count)
                }
            })
        }
    }, [dateSearch.dow, weeklyLimit])

    return (
        <>
            {
                current[0][1] && appointments &&
                <div className={`appointment-count ${appointments.length < dayLimit ? 'count-ok' : appointments.length < (dayLimit + extraCount)  ? 'count-warning' : 'count-bad' }`}>
                    <div>
                        <span>{appointments.filter(i => i.lastStatus === 6).length || 0}</span>
                        {' '}
                        <icons.CheckCircle />
                    </div>
                    <div className='divider'/>
                    <div>
                        <span>{appointments.filter(i => i.lastStatus !== 5).length}</span>
                        {' '}
                        <icons.ExclamationCircle />
                    </div>
                    <div className='divider'/>
                    <div>
                        <span>{dayLimit}</span>
                        {' '}
                        <icons.FilterCircle />
                    </div>
                </div>
            }
        </>
    );
}